import CurrencyConverter from "@/components/CustomUI/modules/CurrencyConverter";

const Details = ({ data }) => {
  return (
    <div className="pt-3 pb-3 font-light text-sm border-t border-b border-slate-300">
      <div className="flex items-center justify-between pb-1">
        <span>SubTotal</span>
        <span>
          <CurrencyConverter amount={data.total_mrp} />
        </span>
      </div>

      {data.total_mrp - data.total_price > 0 && (
        <div className="flex items-center justify-between pb-1">
          <span>You Save</span>
          <span className="text-[#59b859] font-bold">
            <span>-</span>
            <CurrencyConverter amount={data.total_mrp - data.total_price} />
          </span>
        </div>
      )}

      <div className="flex items-center justify-between pb-1 font-black	text-lg">
        <span>Total</span>
        <span>
          <CurrencyConverter amount={data.total_price} />
        </span>
      </div>

      <div className="flex items-center justify-between pb-1">
        <span>Tax (Inclusive)</span>
        <span className="text-[#ff857b]">
          <CurrencyConverter amount={data.tax_value} />
        </span>
      </div>

    </div>
  );
};

export default Details;
